import config from "config/api";
import Axios from "axios";
import store from "store";
import Qs from "qs";
import { authenticated, verifyAuthentication } from "routes/Auth/Module";
import { success, error } from "routes/General/Module";
import { message } from "antd";

const methods = ["get", "delete", "head", "options", "post", "put", "patch"];

@autobind
/**
 *
 */
export default class Api {
  /**
   *
   */
  constructor() {
    this.axios = Axios.create({
      baseURL: `${config.protocol}://${config.url}`,

      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      params: {},

      paramsSerializer: (params) => {
        let _params = app.transform.camelToSnake(params);
        return Qs.stringify(_params, {
          arrayFormat: "indices",
          format: "RFC3986",
        });
      },

      transformRequest: [
        (data = {}) =>
          app.transform.fa2en(JSON.stringify(app.transform.camelToSnake(data))),
      ],

      validateStatus: (status) => {
        if (status === 401 && localStorage.getItem("access-token")) {
          store.dispatch(verifyAuthentication());
          // store.dispatch(authenticated(false));
        }

        if (status === 403) {
          app.message(app.translate("routes.auth.error 403"), "warning", 5);
        }

        return status >= 200 && status < 300;
      },

      transformResponse: [
        (data) => {
          if (app._.isEmpty(data)) {
            return data;
          }

          return app.transform.snakeToCamel(JSON.parse(data));
        },
      ],
    });

    methods.map((method) => (this[method] = this._fetch(method)));
  }

  /**
   *
   * @param {string} method
   * @return {Function}
   * @private
   */
  _fetch(method) {
    return (url, { data, params, ...options } = {}) => {
      this.axios.defaults.headers[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("access-token")}`;

      // this.axios.interceptors.response.use(function(res) {
      //   store.dispatch(success(res, url));
      //   // Do something with response data
      //   return res;
      // }, function(err) {
      //   console.log(err);
      //   store.dispatch(error(err, url));
      //   // Do something with response error
      //   return Promise.reject(err);
      // });

      let _params = this.axios.defaults.params;
      if (params) {
        _params = Object.assign({}, _params, params);
      }

      if (["post", "put", "patch"].indexOf(method) > -1) {
        store.dispatch({
          type: "DATA_REQUESTED",
          data,
          url,
          method,
          params: _params,
        });
      }
      function containsEnglishWords(inputString) {
        // Regular expression to match English words
        const englishWordRegex = /[a-zA-Z]+/;

        // Check if the input string contains English words
        return englishWordRegex.test(inputString);
      }
      return this.axios({
        method,
        url,
        data,
        params: _params,
        ...options,
      })
        .then((res, err) => {
          console.log("rescode", res.data.code);
          if (res.data.code >= 400 || res.data.code < 0) {
            console.log("badbadbadbadb", res.data.data.notice.message);
            if (containsEnglishWords(res.data.data.notice.message)) {
              message.error("خطایی از سمت سرور رخ داده است!");
            } else {
              message.error(res.data.data.notice.message);
            }
            app.error(err, _, app.translate("error darim"));
            return res.data;
          } else {
            store.dispatch(error(res, url));
            return res.data;
          }
        })
        .catch((err) => {
          store.dispatch(error(err, url));

          return Promise.reject(err);
        });
    };
  }
}
